/* ============================================
   ProFRSH Search Bar — inline overlay toggle
   ============================================ */
(function() {
  'use strict';

  var searchBar = document.querySelector('[data-search-bar]');
  if (!searchBar) return;

  var input = searchBar.querySelector('[data-predictive-search-input]');

  function openSearch() {
    searchBar.removeAttribute('hidden');
    searchBar.offsetHeight;
    searchBar.classList.add('is-open');
    document.querySelectorAll('[data-search-toggle]').forEach(function(b) {
      b.setAttribute('aria-expanded', 'true');
    });
    setTimeout(function() { if (input) input.focus(); }, 150);
    document.body.style.overflow = 'hidden';
  }

  function closeSearch() {
    searchBar.classList.remove('is-open');
    document.querySelectorAll('[data-search-toggle]').forEach(function(b) {
      b.setAttribute('aria-expanded', 'false');
    });
    document.body.style.overflow = '';
    setTimeout(function() { searchBar.setAttribute('hidden', ''); }, 250);
  }

  /* Use event delegation on document for bulletproof binding */
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-search-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      if (searchBar.classList.contains('is-open')) {
        closeSearch();
      } else {
        openSearch();
      }
      return;
    }

    /* Close when clicking overlay */
    if (e.target.matches('[data-search-bar-overlay]')) {
      closeSearch();
      return;
    }

    /* Close button */
    var close = e.target.closest('[data-search-close]');
    if (close) {
      closeSearch();
      return;
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchBar.classList.contains('is-open')) {
      closeSearch();
    }
  });
})();
